import { render, staticRenderFns } from "./CustomDatabaseInline.vue?vue&type=template&id=84f64b9e&scoped=true"
import script from "./CustomDatabaseInline.vue?vue&type=script&lang=js"
export * from "./CustomDatabaseInline.vue?vue&type=script&lang=js"
import style0 from "./CustomDatabaseInline.vue?vue&type=style&index=0&id=84f64b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f64b9e",
  null
  
)

export default component.exports